export default __webpack_public_path__ + "static/media/round-arrow.d7b76b90.svg";